import basicState from "../../_js/state/basicstate";
import userGeo from "../../_js/state/usergeo";
import timeZone from "../../_js/state/timezone";
import timeNow from "../../_js/state/timenow";
import mapZoom from "../../_js/state/mapzoom";
import _datastore from "./datastore";
import cookies from "js-cookie"
// import { updateObject } from '../../_js/utils');

const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

export default function (widget, defaultState) {
    const m = widget.m;

    // defaultState.forecastId: String||Number,
    // defaultState.forecastTypeId: String,
    const state = basicState(defaultState, widget);
    state.txt = widget.txt;
    const dataStore = _datastore(state, widget);

    userGeo(state, widget);
    timeZone(state, widget);
    timeNow(state, widget);
    mapZoom(state, widget);


    const _localizeTime = function (time) {
        return time + state.tzOffset * HOUR_MS;
    };


    // state.forecasts;
    // state.forecastsById;
    // state.forecast;
    // state.forecastId;
    // state.forecastData;
    // state.timepoint;
    // state.forecastTypeId;
    // state.forecastType;

    let _lastTimelineIndex;
    let _timelineIndex;
    state.setTimelineIndex = function (newIdx) {
        const timeline = state.forecastData.timeline;
        state.timepoint = timeline[newIdx];
        _lastTimelineIndex = _timelineIndex;
        _timelineIndex = newIdx;
        state.emit('timepoint');
    };


    // state.setTimelineTimepoint = function (timepoint) {
    //   state.setTimelineIndex( timepoint.idx );
    // };

    state.setTimelineTime = function (targetTime) {
        const timeline = state.forecastData.timeline;
        let newIdx = 0;

        let lower = 0;
        let upper = timeline.length - 1;
        let foundTime;
        while (lower <= upper) {
            newIdx = Math.floor((lower + upper) / 2);
            foundTime = timeline[newIdx].time;
            if (foundTime < targetTime) {
                lower = newIdx + 1;
            }
            else if (foundTime > targetTime) {
                upper = newIdx - 1;
            }
            else {
                break;
            }
        }
        // Ensure newIdx points to a timepoint with a timestamp higher than targetItme
        if (targetTime > foundTime && newIdx < timeline.length - 1) {
            newIdx += 1;
        }
        if (newIdx > 0) {
            const lowerTime = timeline[newIdx - 1].time;
            const upperTime = timeline[newIdx].time;
            const roundUpPoint = (upperTime - lowerTime) / 3;
            if (upperTime - targetTime > roundUpPoint) {
                newIdx -= 1;
            }
        }

        state.setTimelineIndex(newIdx);
    };


    state.setTimelinePos = function (position) {
        const days = state.forecastData.timelineDays;
        const time = days.startTimeUTC + Math.floor(days.timespan * position);
        state.setTimelineTime(time);
    };


    state.shiftTimelineIndex = function (delta) {
        let newIdx = _timelineIndex + delta;
        newIdx = Math.max(0, Math.min(state.forecastData.timeline.length - 1, newIdx));
        state.setTimelineIndex(newIdx);
        state.preloadTimepoints();
    };


    let autoStepId;
    const autoStepSpeed = 400;
    state.isAutoPlaying = false;
    state.isAutoPlayPausing = false;

    state.autoStepStart = function (delta) {
        delta = delta || 1;
        const edgeIndex = delta < 0 ? 0 : state.forecastData.timeline.length - 1;
        if (_timelineIndex === edgeIndex) {
            state.setTimelineIndex(0);
        } else {
            state.shiftTimelineIndex(delta);
        }
        clearInterval(autoStepId);
        autoStepId = setInterval(function () {
            // edgeIndex may have moved with new data
            let edgeIndex = delta < 0 ? 0 : state.forecastData.timeline.length - 1;
            if (_timelineIndex >= edgeIndex) {
                if (state.isAutoPlayPausing) {
                    state.isAutoPlayPausing = false;
                    state.setTimelineIndex(0);
                } else {
                    state.isAutoPlayPausing = true;
                }
            } else {
                state.shiftTimelineIndex(delta);
            }
            m.redraw();
        }, autoStepSpeed);
        if (!state.isAutoPlaying) {
            state.isAutoPlaying = true;
            state.isAutoPlayPausing = false;
            state.on('forecast-switch', state.autoStepStop);
        }
    };

    state.autoStepStop = function () {
        clearInterval(autoStepId);
        if (state.isAutoPlaying) {
            state.isAutoPlaying = false;
            state.isAutoPlayPausing = false;
            state.off('forecast-switch', state.autoStepStop);
        }
    };


    state.isAtTimelineStart = function () {
        return _timelineIndex === 0;
    };
    state.isAtTimelineEnd = function () {
        return _timelineIndex === state.forecastData.timeline.length - 1;
    };


    state.refreshTimelineIndex = function () {
        const nowPoint = state.timepoint || {};
        const nowTime = nowPoint.time || state.timeNow;
        state.setTimelineTime(nowTime);
    };


    const defaultPreloads = 2;
    /**
     * Preload `num` timepoints in the direction of motion and 1 in the opposite direciton.
     * Wrap around both ends of the timeline, loading twice if needed.
     */
    state.preloadTimepoints = function (num) {
        if (num === undefined) num = defaultPreloads;
        const timeline = state.forecastData.timeline;
        const length = timeline.length;

        let start, end;
        if (_timelineIndex > _lastTimelineIndex) {
            start = _timelineIndex - 1;
            end = _timelineIndex + num + 1;
        } else {
            start = _timelineIndex - num;
            end = _timelineIndex + 2;
        }
        while (start < 0) start += length;
        while (end > length) end -= length;

        if (start < end) {
            dataStore.loadTimepointData(timeline.slice(start, end), true);
        } else {
            if (start < length) dataStore.loadTimepointData(timeline.slice(start, length), true);
            if (0 < end) dataStore.loadTimepointData(timeline.slice(0, end), true);
        }
    };

    state.on('timepoint', function () {
        dataStore.loadTimepointData([state.timepoint]);
    });
    state.on('forecasttype', function () {
        dataStore.loadTimepointData([state.timepoint]);
    });


    const _makeLocalizedTimelineDays = function (forecastData) {
        const timeline = forecastData.timeline;
        const startTp = timeline[0];
        const endTp = timeline[timeline.length - 1];

        const staleTimeStart = _localizeTime(forecastData.timestamps.first_stale_time) || endTp.localTime;
        const staleTimeEnd = _localizeTime(forecastData.timestamps.expected_end) || endTp.localTime;

        const endTime = Math.max(endTp.localTime, staleTimeEnd);
        let endDayTime = Math.floor(endTime / DAY_MS) * DAY_MS;
        if (endTime % DAY_MS === 0) {
            endDayTime -= DAY_MS;
        }
        const days = [];
        let d;
        let i = 0;
        const startTime = Math.floor(startTp.localTime / DAY_MS) * DAY_MS;
        do {
            const dtTime = startTime + i * DAY_MS;
            const dt = new Date(dtTime);
            d = {
                startTime: dtTime,
                noonTime: dtTime + 12 * HOUR_MS,
                endTime: dtTime + DAY_MS,
                wday: dt.getUTCDay(),
                date: dt.getUTCDate(),
                month: dt.getUTCMonth(),
                year: dt.getUTCFullYear(),
            };
            days[i] = d;
            i++;
        } while (d.startTime < endDayTime);

        const startDay = days[0];
        const endDay = d;

        days.startTime = startTime;
        days.startTimeUTC = startTime - state.tzOffset * HOUR_MS;
        days.endTime = endDay.endTime;
        days.timespan = days.endTime - days.startTime;

        startDay.startHrs = startTp.hours + startTp.minutes / 60;
        endDay.endHrs = endTp.hours + endTp.minutes / 60;
        endDay.isLast = true;

        days.startPad = (startTp.localTime - days.startTime) / days.timespan;
        days.endPad = (days.endTime - endTp.localTime) / days.timespan;

        if (staleTimeEnd > staleTimeStart) {
            days.staleTailStart = (staleTimeStart - days.startTime) / days.timespan;
            days.staleTailLength = (staleTimeEnd - staleTimeStart) / days.timespan;
        }
        return days;
    };

    const _localizeTimeline = function () {
        const forecastData = state.forecastData;
        if (forecastData._tz !== state.tzCode) {
            const newForecastData = forecastData._tz != null ? Object.assign({}, forecastData) : forecastData;
            const newTimeline = forecastData.timeline.map(function (timepoint) {
                timepoint._idObj = {}; // flag timepoint as changed
                timepoint.localTime = _localizeTime(timepoint.time);
                const tpDate = new Date(timepoint.localTime);
                timepoint.wday = tpDate.getUTCDay();
                timepoint.date = tpDate.getUTCDate();
                timepoint.month = tpDate.getUTCMonth();
                timepoint.year = tpDate.getUTCFullYear();
                timepoint.hours = tpDate.getUTCHours();
                timepoint.minutes = tpDate.getUTCMinutes();
                // timepoint.date0 = ('0'+timepoint.date).substr(-2);
                // timepoint.hours0 = ('0'+timepoint.hours).substr(-2);
                timepoint.minutes0 = ('0' + timepoint.minutes).substr(-2);
                timepoint.hours12 = (timepoint.hours % 12) || 12;
                timepoint.ampm = timepoint.hours < 12 ? 'a' : 'p';
                return timepoint;
            });
            newForecastData._tz = state.tzCode;
            newForecastData.timeline = newTimeline;
            newForecastData.timelineDays = _makeLocalizedTimelineDays(forecastData);
            state.forecastData = newForecastData;
        }
    };
    state.on('timezone', _localizeTimeline);


    state.setPlotType = function (forecastTypeId) {
        forecastTypeId = forecastTypeId || state.forecastTypeId;
        if (!forecastTypeId || !state.forecastData.forecast_types[forecastTypeId]) {
            // Invalid forecastType. Default to first available.
            forecastTypeId = state.forecastData.forecast_typesArr[0].id;
        }
        state.forecastTypeId = forecastTypeId;
        state.forecastType = state.forecastData.forecast_types[forecastTypeId];
        state.selectionToCookie();
        state.emit('forecasttype');
    };


    state.mapImageLoaded = false;

    state.setForecastData = function (forecastData) {
        state.forecastData = forecastData;
        state.mapImageLoaded = false;
        dataStore.fetchImage(forecastData.geo.map_url())
            .then(function () {
                state.mapImageLoaded = true;
                m.redraw();
            });
        state.setPlotType();
        state.setTimezone(state.forecastData.timezones);
        state.refreshTimelineIndex();
        state.emit('forecastdata');
    };


    state.setForecast = function (forecastId) {
        let newForecastId = forecastId || state.forecastId;
        const widgetData = state.widgetData;
        if (!newForecastId || !widgetData.forecastsById[newForecastId]) {
            newForecastId = widgetData.defaultForecastId;
        }
        const switching = forecastId && state.forecastId && state.forecastId !== newForecastId;

        state.forecastId = newForecastId;
        state.forecast = widgetData.forecastsById[newForecastId];

        if (switching) {
            state.emit('forecast-switch');
            state.forecastData = null;
            //state.forecastTypeId = null;
            //state.forecastType = null;
            //state.timepoint = null;
        }
        state.emit('forecast');
        if (switching || !state.forecastData) {
            dataStore.getForecastData({
                forecast: state.forecast,
                callback: state.setForecastData,
            });
        }
    };


    const cookieName = widget.widgetId + ':selection';

    /** Load selection state from cookie */
    state.selectionFromCookie = function () {
        try {
            [state.forecastId, state.forecastTypeId] = cookies.getJSON(cookieName);
        } catch (e) {
            // selection cookie was missing or malformed
        }
    };


    /** Write the current selection to cookie */
    state.selectionToCookie = function () {
        cookies.set(
            cookieName,
            [state.forecastId, state.forecastTypeId], {
                expires: 3,
                sameSite: "strict",
            });
    };


    state.on('init', function () {
        dataStore.getWidgetData({
            callback: function (widgetData) {
                state.widgetData = widgetData;
                state.forecasts = widgetData.forecasts;
                state.forecastsArr = widgetData.forecastsArr;
                state.selectionFromCookie();
                state.emit('widgetData');
                state.setForecast();
            },
        });
    });

    // Redraw widget after updating outside Mithril update cycle
    state.redraw = function (force) {
        m.redraw(force);
    };

    return state;

}
